import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdCheckboxModule} from '@angular/material';
import {AddressModule} from '../address/address.module';
import {BillingAccountModule} from '../billing-account/billing-account.module';
import {IndClientComponent} from './ind-client.component';

@NgModule({
  imports: [AddressModule, BillingAccountModule, CommonModule, FormsModule, MdCheckboxModule],
  declarations: [IndClientComponent],
  exports: [IndClientComponent],
})
export class IndClientModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/ind-client/ind-client.module.ts